import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  CreateCardTemplateRequestDto,
  CreateCardTemplateResponseDto,
  CreateCardRequestDto,
  CreateCardResponseDto,
} from '../model';

const createCardTemplate = async (
  args: CreateCardTemplateRequestDto,
  options?: RequestHandlerOptions
): Promise<CreateCardTemplateResponseDto> => {
  const request = () => apiClient.post('/operations/card/template', args);

  const response = await handleRequest<CreateCardTemplateResponseDto>(
    request,
    options
  );

  return response.data;
};

const createCard = async (
  args: CreateCardRequestDto,
  options?: RequestHandlerOptions
): Promise<CreateCardResponseDto> => {
  const request = () => apiClient.post('/operations/card', args);

  const response = await handleRequest<CreateCardResponseDto>(request, options);

  return response.data;
};

export { createCardTemplate, createCard };
